import { useNavigate } from "react-router-dom";
import { ChevronRightIcon } from "@radix-ui/react-icons";
import { t } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";
// import { Widget } from "@typeform/embed-react"

import { Button } from "src/@/components/ui/button";
import { Routes as AppRoutes } from "#navigation/routes";
import { Alert, AlertDescription } from "src/@/components/ui/alert";
import { Page } from "src/@/components/ui/page";
import { CurrentPeriod } from "#dashboard/types";

import { OnboardingModal } from "./components/onboarding-modal";
import { Warnings } from "./components/warnings";
import { Insights } from "./components/insights";
import { FeatureGrid } from "./components/feature-grid";
import { ComparisonPicker } from "./components/filters/comparison-picker";
import { ChannelPicker } from "./components/filters/channel-picker";
import { CurrentPeriodPicker } from "./components/filters/current-period-picker";
import { CustomHourPicker } from "./components/filters/custom-hour-picker";
import { SectionHeader } from "./components/insights/section-header";
import {
    DashboardFiltersProvider,
    useDashboardContext,
} from "./hooks/use-dashboard-context";
import { IntercomButton } from "./components/intercom-button";

const DashboardContent = () => {
    const navigate = useNavigate();
    const { currentPeriod } = useDashboardContext();

    return (
        <Page className="mb-32">
            <OnboardingModal />
            <Alert className="max-w-xl">
                <AlertDescription className="flex items-center justify-between">
                    <span><Trans>Looking for today's sales?</Trans></span>
                    <Button
                        variant="outline"
                        size="sm"
                        className="font-medium"
                        onClick={() => navigate(AppRoutes.BetaOrders)}
                    >
                        <Trans>Open Daily Report</Trans>{" "}
                        <ChevronRightIcon className="ml-2 h-4 w-4" />
                    </Button>
                </AlertDescription>
            </Alert>

            {currentPeriod === CurrentPeriod.TODAY && (
                <Alert className="mb-4 max-w-xl" variant="warning">
                    <AlertDescription>
                        <span>
                            <Trans>This data refreshes every ~10 minutes. For real-time
                            data, go to Daily Report above.</Trans>
                        </span>
                    </AlertDescription>
                </Alert>
            )}

            <Warnings />
            <div className="space-y-4">
                <div className="relative flex items-center space-x-2 whitespace-nowrap">
                    <CurrentPeriodPicker />
                    <ComparisonPicker />
                    <ChannelPicker />
                    <CustomHourPicker />
                </div>
                <Insights />
            </div>
            <div className="space-y-8">
                <SectionHeader title={t`Featured`} />
                <FeatureGrid />
            </div>
            <IntercomButton />
        </Page>
    );
};

export const DashboardGrid = () => (
    <DashboardFiltersProvider>
        <DashboardContent />
    </DashboardFiltersProvider>
);
